import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    const objUserTk = jwtDecode(token || "") as any;
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['Appkey'] = objUserTk.Appkey;
  }
  return config;
}, error => Promise.reject(error));

export default api;
